import { Table, Row, Col } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { TaskContext } from "../components/TaskContext";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../components/button.css";
import Button from "@mui/material/Button";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Pagination from "@mui/material/Pagination";
import { TextField } from "@mui/material";
import "../components/Dots.css";
import SendIcon from "@mui/icons-material/Send";
import PerformersDataChooseOne from "./PerformersDataChooseOne";
import { apiRequest } from "../components/Config";
import SwapVertIcon from "@mui/icons-material/SwapVert";

export default function PerformersData() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [showRegister, setShowRegister] = useState(false);
  const [showPerformers, setShowPerformers] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [text, setText] = useState("Pobieranie danych...");
  const { taskId, setTaskId } = useContext(TaskContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("searchtasks", "POST", {
          param: searchValue,
        });
        if (Array.isArray(response)) {
          setData(response);
          console.log("td: ", response);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
          setData([]);
        }
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error(error);
      }
    };

    if (userData) fetchData();
  }, [userData, searchValue]);

  const refreshData = () => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("searchtasks", "POST", {
          param: searchValue,
        });
        console.log("response data: ", response);
        setData(response);
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error("Błąd podczas odświeżania danych:", error);
      }
    };
    if (userData) fetchData();
  };

  const handleTaskEdit = (id) => {
    setTaskId(id);
    setShowRegister(false);
    navigate(`/taskedit`);
  };
  const sortedData = Array.isArray(data)
    ? [...data].sort((a, b) => {
        if (sortConfig.key === null) return 0;
        const direction = sortConfig.direction === "asc" ? 1 : -1;

        if (a[sortConfig.key] < b[sortConfig.key]) {
          return -1 * direction;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return 1 * direction;
        }
        return 0;
      })
    : [];
  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      setSearchMode(true);
    } else {
      setSearchMode(false);
    }
  };

  const handlePerformers = (id) => {
    if (userData.permId === "1") {
      setShowPerformers(!showPerformers);
      setTaskId(id);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col xs={4} sm={3}>
            <h4>Zlecenia</h4>
          </Col>
          <Col xs={4} sm={3}>
            <TextField
              name="user"
              label="Wyszukaj zlecenie"
              variant="outlined"
              onChange={(e) => {
                handleSearch(e);
              }}
              fullWidth
            />
          </Col>
        </Row>
        <Row style={{ marginBottom }}>
          {data && data.length > 0 && (
            <Pagination
              count={Math.ceil(data.length / itemsPerPage)}
              page={currentPage}
              onChange={handleChangePage}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          )}
        </Row>
      </ThemeProvider>
      <div className="table-responsive">
        <Table bordered hover>
          <thead>
            <tr>
              <th>LP</th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("location")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Adres obiektu
                </span>
              </th>

              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("reporter")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Od kogo
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("buildingpart")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Czego dotyczy
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("receiveData")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Data utworzenia
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("performerName")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Wykonawca
                </span>
              </th>
              <th></th>
              <th onClick={() => requestSort("id")}>ID</th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("status")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Status
                </span>
              </th>
              <th>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <SwapVertIcon
                    onClick={() => requestSort("completionDate")}
                    style={{ cursor: "pointer", marginRight: "0.6em" }}
                  />
                  Realizacja do:
                </span>
              </th>
              <th>Edycja/Podgląd</th>
            </tr>
          </thead>
          {data.length > 0 && userData.userId ? (
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{item.location}</td>
                  <td>{item.reporter}</td>
                  <td>{item.buildingpart}</td>
                  <td className="td td-green">{item.receiveData}</td>
                  {item.statusId !== "1" ? (
                    <td>{item.performerName}</td>
                  ) : (
                    <td>
                      <ThemeProvider theme={theme}>
                        <Button onClick={() => handlePerformers(item.id)}>
                          <SendIcon />
                        </Button>
                      </ThemeProvider>
                    </td>
                  )}
                  <td>
                    <div className={item.class}>[{item.id}]</div>
                  </td>
                  <td>[{item.id}]</td>
                  <td>{item.status} </td>
                  {item.nearexpired === "1" ? (
                    <td style={{ color: "red" }}>{item.completionDate} </td>
                  ) : (
                    <td>{item.completionDate}</td>
                  )}
                  <td>
                    <ThemeProvider theme={theme}>
                      <Button
                        variant="outlined"
                        onClick={() => handleTaskEdit(item.id)}
                      >
                        <i className="fa fa-edit" aria-hidden="true"></i>
                      </Button>
                    </ThemeProvider>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  <h6>{text}</h6>
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
      <Row style={{ marginBottom }}>
        {data && data.length > 0 && (
          <Pagination
            count={Math.ceil(data.length / itemsPerPage)}
            page={currentPage}
            onChange={handleChangePage}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        )}
      </Row>
      {showPerformers && (
        <PerformersDataChooseOne taskId={taskId} refreshData={refreshData} />
      )}
    </div>
  );
}
